/* eslint-disable react/react-in-jsx-scope */

const CATEGORY_TO_PAYMENT_TYPES = {
  ACH: ["ACH"],
  ACH_LEGACY: ["ACH_LEGACY"],
  CARD: [
    "AMEX_NOT_PRESENT",
    "AMEX_PRESENT",
    "CARDPOINTE_CARD",
    "COMMERCIAL_CARD",
    "CORPORATE_CARD",
    "CREDIT_CARD_NOT_PRESENT",
    "CREDIT_CARD_PRESENT",
    "DEBIT_CARD_NOT_PRESENT",
    "DEBIT_CARD_PRESENT",
    "MANUAL_CARD_TRANSACTION",
    "PREPAID_CARD",
    "RUPAY_CREDIT_CARD_NOT_PRESENT",
    "RUPAY_CREDIT_CARD_PRESENT",
    "RUPAY_NOT_PRESENT",
    "RUPAY_PRESENT",
    "SUPER_PREMIUM_CARD",
  ],
  CHALLAN: ["CHALLAN"],
  INSTANT_ACH: ["INSTANT_ACH"],
  INSTANT_PAYMENT: ["INSTANT_PAYMENT"],
  NET_BANKING: [
    "NET_BANKING_ADITYA_BIRLA_PAYMENT_BANK",
    "NET_BANKING_AIRTEL_PAYMENTS_BANK",
    "NET_BANKING_ALLAHABAD_BANK",
    "NET_BANKING_ALLAHABAD_BANK_CORPORATE",
    "NET_BANKING_ANDHRA_BANK",
    "NET_BANKING_ANDHRA_BANK_CORPORATE",
    "NET_BANKING_ANDHRA_PRAGATHI_GRAMEENA_BANK",
    "NET_BANKING_AU_SMALL_FINANCE",
    "NET_BANKING_AU_SMALL_FINANCE_BANK_CORPORATE",
    "NET_BANKING_AXIS_BANK",
    "NET_BANKING_AXIS_BANK_CORPORATE",
    "NET_BANKING_BANDHAN_BANK_CORPORATE_BANKING",
    "NET_BANKING_BANDHAN_BANK_RETAIL_NET_BANKING",
    "NET_BANKING_BANK_OF_BAHRAIN_AND_KUWAIT",
    "NET_BANKING_BANK_OF_BARODA_CORPORATE",
    "NET_BANKING_BANK_OF_BARODA_RETAIL_BANKING",
    "NET_BANKING_BANK_OF_INDIA",
    "NET_BANKING_BANK_OF_INDIA_CORPORATE",
    "NET_BANKING_BANK_OF_MAHARASHTRA",
    "NET_BANKING_BARCLAYS_CORPORATE_CORPORATE_BANKING_CORPORATE",
    "NET_BANKING_BASSEIN_CATHOLIC_BANK",
    "NET_BANKING_BNP_PARIBAS",
    "NET_BANKING_CANARA_BANK",
    "NET_BANKING_CAPITAL_BANK",
    "NET_BANKING_CATHOLIC_SYRIAN_BANK",
    "NET_BANKING_CENTRAL_BANK_OF_INDIA",
    "NET_BANKING_CITIBANK",
    "NET_BANKING_CITY_UNION_BANK",
    "NET_BANKING_CITY_UNION_BANK_OF_CORPORATE",
    "NET_BANKING",
  ],
  RAPID_ACH: ["RAPID_ACH"],
  RFP: ["RFP"],
  SWIFT_ACH: ["SWIFT_ACH"],
  UPI: ["QR", "UPI_INDENT", "UPI_NOT_PRESENT", "UPI_PRESENT"],
  WALLET: ["APPLE_PAY_US", "GOOGLE_PAY_US", "PAYPAL_WALLET", "SWIREPAY_US", "VENMO", "ZELLE"],
  X_ACH: ["X_ACH"],
  ZIP_ACH: ["ZIP_ACH"],
};

const expandCategoryToPaymentTypes = (categories) => {
  if (categories) {
    return categories.flatMap(category => CATEGORY_TO_PAYMENT_TYPES[category] ?? [category]);
  }
};

export default expandCategoryToPaymentTypes;
